import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { post } from '../../helpers/api_helper';

function AddressForm(props) {
  const {
    actionUrl,
    entity,
    t,
  } = props;

  const [, setLoading] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);

      toastr.success(t(`Address ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      toastr.error(t('Error saving address'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    address_1: Yup.string().required(),
    address_2: Yup.string().nullable(),
    city: Yup.string().required(),
    region: Yup.string().max(2, 'State must be 2 characters'),
    postcode: Yup.string().required(),
    country: Yup.string().max(2, 'Country must be 2 characters').required(),
  });

  const jsx = (
    <div>
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          // eslint-disable-next-line no-unused-vars
          touched, errors, setFieldValue, values,
        }) => (
          <Form id="AddressForm" autoComplete="off">
            <div className="mb-3">
              <Label for="company" className="text-dark">{t('Company')}</Label>
              <Field id="company" name="company" type="text" className="form-control" />
              <ErrorMessage name="company" component="div" className="text-danger" />
            </div>
            <div className="mb-3">
              <Label for="address" className="text-dark">{t('Address')}</Label>
              <Field id="address" name="address_1" type="text" className="form-control" />
              <ErrorMessage name="address_1" component="div" className="text-danger" />
              <Field name="address_2" type="text" className="form-control mt-2" />
            </div>
            <div className="mb-3">
              <Row>
                <Col xl="4">
                  <Label for="city" className="text-dark">{t('City')}</Label>
                  <Field id="city" name="city" type="text" className="form-control" />
                  <ErrorMessage name="city" component="div" className="text-danger" />
                </Col>
                <Col xl="4">
                  <Label for="state" className="text-dark">{t('State')}</Label>
                  <Field id="state" name="region" type="text" className="form-control" />
                  <ErrorMessage name="region" component="div" className="text-danger" />
                </Col>
                <Col xl="4">
                  <Label for="zip" className="text-dark">{t('Zip')}</Label>
                  <Field id="zip" name="postcode" type="text" className="form-control" />
                  <ErrorMessage name="postcode" component="div" className="text-danger" />
                </Col>
              </Row>
            </div>
            <div className="mb-3">
              <Row>
                <Col xl="4">
                  <Label for="country" className="text-dark">{t('Country')}</Label>
                  <Field id="country" name="country" type="text" className="form-control" />
                  <ErrorMessage name="country" component="div" className="text-danger" />
                </Col>
                <Col xl="8">
                  <Label for="phone" className="text-dark">{t('Telephone')}</Label>
                  <Field id="phone" name="telephone" type="text" className="form-control" />
                  <ErrorMessage name="telephone" component="div" className="text-danger" />
                </Col>
              </Row>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );

  return jsx;
}

AddressForm.defaultProps = {
  entity: { stock_id: '', items: [] },
  onSuccess: () => {},
};

AddressForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(AddressForm));
